export type SearchFilters = {
    [key: string]: any;
};

export type EventLogsQuery = {
    readonly page: number;
    readonly hitsPerPage: number;
    readonly filters: SearchFilters;
    readonly searchText: string;
};

export const commonEventsQueryBuilder = {
    createEmptyQuery(): EventLogsQuery {
        return {
            page: 1,
            hitsPerPage: 100,
            searchText: '',
            filters: {},
        };
    },

    cleanQuery(query: EventLogsQuery): string {
        return encodeURIComponent(JSON.stringify(query));
    },

    updateFilters(query: EventLogsQuery, newFilters: SearchFilters): EventLogsQuery {
        return {
            ...query,
            filters: newFilters,
        };
    },

    loadSpecifiedPage(query: EventLogsQuery, pageNumber: number): EventLogsQuery {
        return {
            ...query,
            page: pageNumber,
        };
    },
};
